import React from 'react'
import { checkTextTranslation, checkTranslation, getObject, statusConvertor, translate } from '../../utils/useful'
import FixedView from '../FixedView'

class TableStatusSelectInput extends React.Component {
    state = {
        // status:{
        //     'C':{key:'C',label:'{{lang}}Connected',color:'#fff',backgroundColor:'007aff'},
        //     'P':{key:'P',label:'{{lang}}Pending',color:'#fff',backgroundColor:'#9ab'},
        //     'S':{key:'S',label:'{{lang}}Self',color:'#fff',backgroundColor:'#000'},
        // }
    }


    componentDidMount() {

    }



    getInfo(data) {
        let items = this.props.header?.information?.items
        let info
        if (Array.isArray(items)) {
            items.forEach(item => {
                if (data == item.key) {
                    info = item
                }
            });
        }

        return info

    }

    openList = () => {
        this.fixedView.showView()
    }


    changeValue = (item) => {
        let value = item?.key
        this.props.changeValue(this.props.header.key, value, this.props.extra)
        this.fixedView.hideView()
    }



    render() {
        let info = this.getInfo(this.props.data)
        return (
            <div className="w-100 h-100 flexc status-select-input position-relative" ref={el => this.nodeRef = el}>
                <div className='flexc  w-100'  >
                    <p className="text-capitalize text-smaller  select-option br-20" style={{ color: info?.color, backgroundColor: info?.bgColor }}>{checkTranslation(info?.label)}</p>
                </div>
                {/* <FixedView ref={el => this.fixedView = el} nodeRef={this.nodeRef} maxHeight={200} topOffset={2} bottomOffset={24} xOffset={4} zIndex={10}>

                    <div className=' br-10 bg-white shadow-2  py-3' style={{ top: 30, minWidth: 150, maxHeight: 200 }}>


                        <div className='px-3'>
                            {this.props.header?.information?.items?.map((item, index) => {
                                return (
                                    <div className='mb-2 flexc ' key={item.key} onClick={() => this.changeValue(item)}>
                                        
                                        <p className="text-capitalize text-smaller text-center select-option br-20 cursor-pointer" style={{ color: item?.color, backgroundColor: item?.bgColor }}>{checkTranslation(item?.label)}</p>
                                    </div>
                                )
                            })}
                        </div>

                        <div className='flexcb pt-2 px-3' style={{ borderTop: '1px solid #f0f0f0' }}>
                            <div className='flexc cursor-pointer' style={{ color: '#999' }}>
                                <p>{translate('Edit Labels')}</p>
                            </div>

                            <div className=' flexc cursor-pointer' onClick={() => this.changeValue()}>
                                <p className="text-capitalize text-smaller text-center px-1" style={{ color: '#007aff' }}>Clear</p>
                            </div>
                        </div>


                    </div>
                </FixedView> */}

            </div>
        )
    }
}

export default TableStatusSelectInput;